import "../src/types/globalscope.ts";

// Depends on the ComBridgeServer but not at load time.

var debugMode = true;

function getCookie(c_name) {
    var c_value = " " + document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) {
        c_value = null;
    }
    else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start,c_end));
    }
    return c_value;
}
function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
}

// Old GA API for those who still have this in their site
function setGoogleOldGACookies(utm) {
    if(utm.__utma != null) {
        var curUTMA = getCookie("__utma");
        if(curUTMA != utm.__utma) {
            console.log("Importing old GA IDs", utm);
            // https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
            if(utm.__utma != null) setCookie('__utma', utm.__utma, 730);
            if(utm.__utmz != null) setCookie('__utmz', utm.__utmz, 182);
        }
        else if(debugMode)
            console.log("Same old GA ID");
    }
}

// New analytics.js API
function setGoogleAnalyticsCookies(anal) {
    if(anal._ga != null) {
        var curGA = getCookie("_ga");
        if(curGA != anal._ga) {
            console.log("Importing Google Analytics IDs", anal);
            // https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
            if(anal._ga != null) setCookie('_ga', anal._ga, 730);
            if(anal._gid != null) setCookie('_gid', anal._gid, 1);
        }
        else if(debugMode)
            console.log("Same google analytics ID");
    }
}

function setFacebookCookies(fb) {
    if(fb._fbp != null) {
        var curFB = getCookie("_fbp");
        if(curFB != fb._fbp) {
            console.log("Importing Facebook ID", fb);
            // https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
            if(fb._fbp != null) setCookie('_fbp', fb._fbp, 730);
        }
        else if(debugMode)
            console.log("Same Facebook ID");
    }
}

window.RCOMBRIDGE_copyTrackingCookies = function() {
    if(typeof RCOMBRIDGE_getTrackingCookies !== 'undefined') {
        window.RCOMBRIDGE_getTrackingCookies(function (tCookies) {
            setFacebookCookies(tCookies.facebook);
            setGoogleOldGACookies(tCookies.ga);
            setGoogleAnalyticsCookies(tCookies.analytics);
        });
    }
};


